import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/wix': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M393.4 131.7C393.4 144.7 395.5 164.4 364.7 175.5 355.2 179 348.8 185.2 348.8 185.2 348.8 154.2 353.5 143 366.1 136.3 375.9 131.2 393.4 131.7 393.4 131.7zM277.6 167.2L243.3 299.9 214.9 191.3C207.2 159.3 194.1 142.8 166.4 142.8 139.1 142.8 125.8 159 118 191.3L89.5 299.9 55.3 167.2C49.7 140.5 23.9 129 0 132L65.6 379.9S87.2 381.4 98 375.9C112.3 368.7 119 363.1 127.6 329.4 135.3 299.3 156.7 210.9 158.7 204.7 163.5 189.7 169.8 190.9 174.1 204.7 176.1 211 197.6 299.3 205.3 329.4 213.9 363.1 220.6 368.7 234.8 375.9 245.7 381.4 267.3 379.9 267.3 379.9L332.9 132C308.5 128.9 283.1 140.9 277.6 167.2zM393.4 172.4S389.3 178.8 379.9 184C373.9 187.4 368.1 189.6 361.9 192.6 346.8 199.9 348.8 206.6 348.8 227.8V379.9S365.3 382 376.1 376.5C390.1 369.4 393.3 362.5 393.4 331.7V181.4L393.4 181.4V172.4zM556.8 256.5L640 132.8S604.9 126.8 587.5 142.6C574.2 154.7 563.1 172.2 533.3 215.1 532.9 215.8 527.1 225.6 520.3 215.1 491 172.9 479.4 154.8 466.1 142.6 448.7 126.8 413.6 132.8 413.6 132.8L496.8 256.5 413.8 379.9S450.4 384.5 467.7 368.7C479.2 358.2 485.3 348.3 520.3 297.9 527.1 287.4 532.8 297.2 533.3 297.9 562.7 340.3 572.6 356 586.5 368.7 603.9 384.5 639.8 379.9 639.8 379.9L556.8 256.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/wix.js
// module id = KajL
// module chunks = 144